import type { RouterProps } from 'piral-core'
import type * as React from 'react'
import { BrowserRouter } from 'react-router-dom'

export const DefaultRouter: React.FC<RouterProps> = ({ children, publicPath }) => {
  return <BrowserRouter basename={publicPath}>{children}</BrowserRouter>
}
DefaultRouter.displayName = 'DefaultRouter'
